import React, { useRef } from 'react';
import { Select, Input } from 'antd';
import SingleSelector from './SingleSelector';
import PeriodRangePicker from './PeriodRangePicker';
import { useDisableMapInteractions } from '../hooks/useDisableMapInteractions'
import { useGlobalLoading } from '../context/LoadingContext';

export default function RoseMenu({
  parameterOptions,
  selectedParam,
  setSelectedParam,
  periodicityRose,
  setPeriodicityRose,
  anemometerDevices,
  selectedAnemometerId,
  setSelectedAnemometerId,
  periodPickerRef,
  customRange,
  setCustomRange,
  showCustom,
  setShowCustom,
  setPreset,
  selectedPreset,
  selectedLabel,
  presetDefs,
  breakPoints,
  setBreakPoints,
  fetchAndGenerateRoses,
  onClose, 
  mapRef
}) {
  const ref = useRef(null);
  useDisableMapInteractions(ref, mapRef);
  const { loading } = useGlobalLoading();
  return (
    <div
      ref={ref}
      className="map-card map-card-interactive"
      style={{
        width: 340
      }}
    >
      <div className="map-card-title">
        Pollution Rose
      </div>

      <div className="map-card-content">
        <SingleSelector
          items={parameterOptions}
          value={selectedParam}
          onChange={setSelectedParam}
          idKey="id"
          labelKey="name"
          placeholder="Select parameter"
          width="100%"
          getPopupContainer={() => document.body}
        />

        <Select
          value={periodicityRose}
          onChange={setPeriodicityRose}
          getPopupContainer={trigger => trigger.parentNode}
          placeholder="Select aggregation"
        >
          <Select.Option value="AVG5M">AVG 5M</Select.Option>
          <Select.Option value="AVG15M">AVG 15M</Select.Option>
          <Select.Option value="AVG1H">AVG 1H</Select.Option>
          <Select.Option value="AVG24H">AVG 24H</Select.Option>
        </Select>

        <SingleSelector
          items={anemometerDevices}
          value={selectedAnemometerId}
          onChange={setSelectedAnemometerId}
          idKey="id"
          labelKey="name"
          placeholder="Select device with anemometer"
          width="100%"
          getPopupContainer={() => document.body}
        />

        <PeriodRangePicker
          ref={periodPickerRef}
          value={customRange}
          onChange={setCustomRange}
          showCustom={showCustom}
          setPreset={setPreset}
          setShowCustom={setShowCustom}
          selectedPreset={selectedPreset}
          selectedLabel={selectedLabel}
          presetDefs={presetDefs}
          width="100%"
        />

        <Input
          value={breakPoints}
          onChange={e => setBreakPoints(e.target.value)}
          placeholder="Break points (optional, e.g. 2,5,8,14)"
        />
      </div>

      <div className="map-card-actions">
        <button
          className="map-card-primary-button"
          disabled={loading}
          onClick={async () => {
            const ok = await fetchAndGenerateRoses();
            if (ok) onClose();
          }}
        >
          {loading ? 'Loading...' : 'Load data'}
        </button>

        <button
          className="map-card-secondary-button"
          onClick={onClose}
        >
          Close
        </button>
      </div>

    </div>
  );
}
